import { PdfContratoPageComponent } from './../pdf-contrato-page/pdf-contrato-page.component';
import { Component, ComponentFactoryResolver, Inject, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import html2pdf from 'html2pdf.js';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Coletor } from '../coletor/coletor';
import { Doador } from '../doador/doador';


export interface DialogData {
  doador: Doador;
  coletor: Coletor;
  coletaValida: boolean;
}
@Component({
  selector: 'app-pdf-contrato-create',
  templateUrl: './pdf-contrato-create.component.html',
  styleUrls: ['./pdf-contrato-create.component.css']
})
export class PdfContratoCreateComponent implements OnInit {

  @ViewChild('contratoPDF', { static: true, read: ViewContainerRef }) contratoPDF: ViewContainerRef;

  constructor(
    private readonly resolver: ComponentFactoryResolver,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
    this.createPDF();
  }

  createPDF(): void {
    this.contratoPDF.clear();
    const factory = this.resolver.resolveComponentFactory(PdfContratoPageComponent);
    const componentRef = this.contratoPDF.createComponent(factory);

    componentRef.instance.doador = this.data.doador
    componentRef.instance.coletor = this.data.coletor;
    componentRef.instance.coletaValida = this.data.coletaValida;

    componentRef.instance.emitter.subscribe(() => {
      const config = {
        html2canvas: {
          scale: 1,
          scrollX: 0,
          scrollY: 0,
        },
      };

      this.print(componentRef.location.nativeElement, config);
      componentRef.destroy();
    });
  }


  print(content: any, config: any): void {
    // html2pdf()
    //   .set(config)
    //   .from(content)
    //   .toPdf()
    //   .outputPdf('dataurnewwindow').save("Contrato");
    html2pdf().from(content).toPdf().get('pdf').then(function (pdf) {
      window.open(pdf.output('bloburl'), '_blank',);
    });
  }

}
